import { render } from "./detail.vue?vue&type=template&id=529a347c&scoped=true&ts=true"
import script from "./detail.vue?vue&type=script&lang=ts"
export * from "./detail.vue?vue&type=script&lang=ts"

import "./detail.vue?vue&type=style&index=0&id=529a347c&lang=scss&scoped=true"
import "./detail.vue?vue&type=style&index=1&id=529a347c&lang=scss"

import exportComponent from "/Users/wangyong/shanggeyun/code/sagacloud-sagacare-ipad/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-529a347c"]])

export default __exports__